import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Select } from '@alifd/next';
import { FlagIcon } from '@alife/bc-icbu-icon';
import safeLog from '@alife/bc-safe-log';
import './index.scss';

export default class AftersaleWidget extends Component {
  static propTypes = {
    className: PropTypes.string,
    dtClassName: PropTypes.string,
    ddClassName: PropTypes.string,
    defaultCountry: PropTypes.string,
    i18n: PropTypes.shape({
      aftersale: PropTypes.string,
      aftersaleBalloonTitle: PropTypes.string,
      aftersalseBalloonText: PropTypes.string,
    }),
    balloonClass: PropTypes.string,
    pid: PropTypes.number,
    tempId: PropTypes.number,
    lang: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentCountry: null,
      showDialog: false,
      rules: [],
    };
    this.el = null;
  }

  componentDidMount() {
    fetch(
      `/event/app/mainAction/afterSale.htm?afterSaleTemplateId=${this.props.tempId}&detailId=${this.props.pid}&language=${this.props.lang}`,
    )
      .then(res => res.json())
      .then((data = {}) => {
        const { success, rules } = data;
        if (success) {
          const hasDefaultRules = this.props.defaultCountry
            ? rules.find(c => c === this.props.defaultCountry)
            : null;
          this.setState(
            {
              ...this.state,
              rules,
              currentRule: hasDefaultRules ? hasDefaultRules : rules[0],
            },
            () => {
              if (this.el && this.props.showSplitLine) {
                const splitLine = document.createElement('div');
                splitLine.className = 'split-line';
                this.el.parentElement.insertBefore(splitLine, this.el);
              }
            },
          );
        }
      });
  }

  handleClick = () => {
    this.setState({
      ...this.state,
      showDialog: true,
    });
    safeLog(
      '/sc.details.commonLogs',
      'CLK',
      `info=pid=${this.props.pid}&action=aftersale_country_click`,
      'GET',
    );
  };

  handleConfirm = () => {
    this.setState({
      ...this.state,
      showDialog: false,
    });
  };

  handleClose = () => {
    this.setState({
      ...this.state,
      showDialog: false,
    });
  };

  handleCountryClick = c => () => {
    this.setState({
      ...this.state,
      currentCountry: c,
    });
  };

  handleHover = () => {
    safeLog(
      '/sc.details.commonLogs',
      'CLK',
      `info=pid=${this.props.pid}&action=aftersale_hover`,
      'GET',
    );
  };

  handleSelectChange = value => {
    this.setState({
      ...this.state,
      currentRule: this.state.rules.find(r => r.country === value),
    });
  };

  render() {
    const { props } = this;
    const { i18n = {} } = props;
    if (this.state.rules.length === 0) return null;
    const { currentRule } = this.state;
    return (
      <dl
        className={`aftersale-widget ${props.className}`}
        ref={el => (this.el = el)}
      >
        <dt className={props.dtClassName}>
          {i18n.aftersale || 'Local after-sales:'}
        </dt>
        <dd className={props.ddClassName}>
          <span>{currentRule && currentRule.services[0]} in </span>
          <FlagIcon type={currentRule.country} size="medium" />
          <span
            className="current-country-name"
            onClick={this.handleClick}
            onMouseEnter={this.handleHover}
          >
            {currentRule.fullCountryName}
          </span>
          <Dialog
            footer={false}
            visible={this.state.showDialog}
            onClose={this.handleClose}
            title={i18n.aftersaleBalloonTitle || 'Local After-sales'}
            className="aftersale-dialog"
          >
            <span className="aftersale-dialog-text">
              {i18n.aftersalseBalloonText || 'Select country/region '}
            </span>
            <Select
              onChange={this.handleSelectChange}
              defaultValue={currentRule.country}
            >
              {this.state.rules.map(c => {
                return (
                  <Select.Option value={c.country} key={c.country}>
                    <FlagIcon type={c.country} size="medium" />
                    {c.fullCountryName}
                  </Select.Option>
                );
              })}
            </Select>
            <ul className="services-in-country">
              {currentRule.services.map(s => (
                <li key={s}>{s}</li>
              ))}
            </ul>
          </Dialog>
        </dd>
      </dl>
    );
  }
}
